export { default as GroupPacDetails } from './GroupPacDetails';
